import { useRouter } from "next/router";
import React from "react";
import { Event } from "../../../context/eventsContext/reducer";
import ReadMore from "../Buttons/ReadMore";
import EventDate from "./elements/EventDate";
import EventLocation from "./elements/EventLocation";

const EventPreview = (props: {
  event: Event,
  hideImage?: boolean,
  className?: string
}) => {
  const router = useRouter();

  const handleClick = () => {
    router.push(`/events/${ props.event.slug }`)
  }

  return (
    <div
      className={`transition article-container rounded shadow-md hover:shadow-lg flex overflow-hidden cursor-pointer relative ${props.className}`}
      onClick={handleClick}
      onKeyDown={(e) => {if (e.key === "Enter") handleClick()}}
      role="button"
      tabIndex={0}
    >
      {
        !props.hideImage &&
        <div className="relative overflow-hidden hidden md:block max-w-xs w-full">
          <div
            className="article-image h-0 aspect-16/9 w-full bg-cover bg-center flex items-center justify-center"
            style={{
              backgroundImage: `url("${props.event.image_url}")`
            }}
          >
            {
              props.event.image_url.includes('missing.png') &&
              <div className="relative p-12 w-full">
                <div className="absolute -inset-20 z-10 leading-10 text-3xl font-bold text-red opacity-10 transform -rotate-12">
                  {(props.event.title + " ").repeat(50)}
                </div>
              </div>
            }
          </div>
        </div>
      }

      <div className="p-5 flex flex-col w-full">
        <div className="h-full flex flex-col space-y-1">
          <h2 className="transition font-bold text-xl mb-2">
            {props.event.title}
          </h2>

          <div className="h-full"></div>

          <div>
            <EventDate
              className="w-full"
              event={props.event}
            />

            <EventLocation 
              event={props.event}
            />
          </div>
        </div>

        <ReadMore 
          className="pt-4 absolute bottom-5 left-0 right-6"
          label=" "
          link="#"
          needLink={false}
        />
      </div>
    </div>
  );
};

export default EventPreview;
